import { FC } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoaderProps {
    className?: string;
    loaderText?: string;
    loaderClassname?: string;
    loaderTextClassname?: string;
    customLoaderText?: React.ReactNode;
}

const Loader: FC<LoaderProps> = ({ className, loaderText, loaderClassname, loaderTextClassname, customLoaderText }) => {
    return (
        <div
            className={
                cn(
                    "text-primary-color min-h-[200px] flex flex-col justify-center items-center",
                    className
                )
            }
        >
            <Loader2
                className={
                    cn(
                        "h-10 w-10 animate-spin",
                        loaderClassname
                    )
                }

            />
            {customLoaderText ||
                <h2
                    className={
                        cn(
                            "mt-3 text-lg text-primary-color text-center",
                            loaderTextClassname
                        )
                    }
                >
                    {loaderText || "Please wait"}...
                </h2>
            }
        </div>
    );
};

export default Loader; 